import AnniversaryPage from './containers/ArticleVisitContainer'

export default store => {
  return {
    path: 'sample-visit',
    exact: true,
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, AnniversaryPage, 'articles')
      })
    },
  }
}
